import { render, staticRenderFns } from "./FormDespacho.vue?vue&type=template&id=62bd713a"
import script from "./FormDespacho.vue?vue&type=script&lang=js"
export * from "./FormDespacho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports